// extracted by mini-css-extract-plugin
module.exports = {"trigger":"Tooltip_trigger__rv3CT","content":"Tooltip_content__M1HW4"};